export const Tokens = {
  slides: Symbol('slides'),
  carouselContext: Symbol('carouselContext'),
} as const;
